export const offer = "OFFER!! 50% OFF ON 1 MONTH SUBSCRIPTION";
